<template>
  <div>
    <h1 class="title">{{ $t('account.password-change') }}</h1>
    <div class="box">
      <b-notification type="is-success" v-if="successFullChanged" :closable="false">
        {{ $t('account.password-changed-success') }}
      </b-notification>
      <b-notification type="is-danger" v-if="errors && errors.length > 0" :closable="false">
        <ul>
          <li v-for="(e, i) in errors" :key="i">{{ e }}</li>
        </ul>
      </b-notification>
      <ValidationObserver v-slot="{invalid}">
        <form>
          <ValidationProvider name="altes Passwort" :rules="{required: true, min: 6}" v-slot="{errors}">
            <b-field :label="$t('account.old-password')">
              <b-input type="password" v-model="oldpassword" password-reveal></b-input>
              <p class="help is-danger" v-for="error in errors" :key="error">{{ error }}</p>
            </b-field>
          </ValidationProvider>
          <ValidationProvider name="neues Passwort" :rules="{required: true, min: 6, confirmed: 'confirmation'}" v-slot="{errors}">
            <b-field :label="$t('account.new-passowrd')">
              <b-input type="password" v-model="newpassword" password-reveal></b-input>
              <p class="help is-danger" v-for="error in errors" :key="error">{{ error }}</p>
            </b-field>
          </ValidationProvider>
          <ValidationProvider name="neues Passwort wiederholen" vid="confirmation" :rules="{required: true, min: 6}" v-slot="{errors}">
            <b-field :label="`${$t('account.new-passowrd')} ${$t('general.retry')}`">
              <b-input type="password" v-model="passwordVerify" password-reveal></b-input>
              <p class="help is-danger" v-for="error in errors" :key="error">{{ error }}</p>
            </b-field>
          </ValidationProvider>
          <div class="is-sticky-mobile--bottom u-has-background-white-o75  u-p1--mobile">
            <b-button type="is-primary" class="is-fullwidth--desktop mt-4" size="is-medium" :disabled="invalid" @click="change" expanded>{{ $t('account.password-change') }}</b-button>
          </div>
        </form>
      </ValidationObserver>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UserChangePassword',
  data() {
    return {
      newpassword: '',
      oldpassword: '',
      passwordVerify: '',
      errors: [],
      successFullChanged: false,
    }
  },
  methods: {
    async change() {
      this.errors = []

      this.successFullChanged = false
      let res = await this.$store.dispatch('$_account/changePassword', {old: this.oldpassword, new: this.newpassword})
      if (res.passwordChanged) {
        // this.newpassword = ''
        // this.oldpassword = ''
        // this.passwordVerify = ''
        this.successFullChanged = true
      } else {
        this.errors = res.errors
      }
    },
  },
}
</script>

<style scoped lang="scss"></style>
